// extracted by mini-css-extract-plugin
export default {"container":"_25_RO","gridContainer":"_3wAxc","headerContainer":"_1x0DL","header":"_70hg3","content":"EzF0D","controls":"lDL5c","separator":"_3njQI"};